import {SketchPicker} from "react-color";

import BaseComponent from "../baseComponent.js";
import styles from './styles.scss';
import InternalEvent from "../../core/constants/internalEvent";
import DashboardService from "../../core/services/dashboardService";

export default class DashboardConfiguration extends BaseComponent {
  constructor(props) {
    super(props);
    const dashboardColors = DashboardService.getCurrentDashboardVariableById("colors") || props.getDefaultDashboardColors();
    this.state = {
      background: dashboardColors.background
    };
    this.isPickerOpen = false;
  }

  componentWillReceiveProps(nextProps) {
    const dashboardColors = DashboardService.getCurrentDashboardVariableById("colors") || this.props.getDefaultDashboardColors();
    this.setState({
      background: dashboardColors.background
    });
  }

  handleChangeComplete(color) {
    this.setState({background: color.hex});
  }

  showColorPicker(e) {
    const popupOffset = $(this.refs.popup).offset();
    $(this.refs.picker).css({
      top: popupOffset.top + e.target.offsetTop + 25,
      right: 10,
      display: "block"
    });
    this.isPickerOpen = true;
  }

  handleBackdropClick() {
    if(this.isPickerOpen) {
      $(this.refs.picker).hide();
      this.isPickerOpen = false;
    } else {
      $(this.refs.container).hide();
    }
  }

  show() {
    $(this.refs.container).show();
  }

  apply() {
    this.publish(InternalEvent.App.COLOR_CHANGED, {background: this.state.background});
    DashboardService.updateDashboardVariables({
      colors: {
        id: "colors",
        background: this.state.background
      }
    });
    $(this.refs.container).hide();
  }

  applyAll() {
    this.publish(InternalEvent.App.COLOR_CHANGED, {background: this.state.background});
    DashboardService.getAllDashboards()
      .then(dashboards => {
        dashboards.forEach(d => {
          const dashboardCopy = JSON.parse(JSON.stringify(d));
          dashboardCopy.variables["colors"] = {
            id: "colors",
            background: this.state.background
          };
          DashboardService.updateDashboard(d, dashboardCopy);
        })
      });
    $(this.refs.container).hide();
  }

  render() {
    return (
      <div ref="container" style={{display: "none"}}>
        <div className={styles.detailBackdrop} onClick={this.handleBackdropClick}/>
        <div className={styles.configuration} ref="popup">
          <div className={styles.configLine}>
            <div className={styles.configLabel}>Background</div>
            <div className={styles.configColor} style={{background: this.state.background}}
                 onClick={this.showColorPicker}/>
          </div>
          <div style={{flex: 1}}/>
          <div className={styles.apply}>
            <div onClick={this.applyAll}>Apply All</div>
            <div onClick={this.apply}>Apply</div>
          </div>
          <div style={{position: "fixed ", display: "none"}} ref="picker">
            <SketchPicker color={this.state.background} onChangeComplete={this.handleChangeComplete}/>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardConfig.jsx